<!-- Select Option -->
<mat-checkbox class="table-checkbox" aria-label="tableCheckbox" [attr.data-test-id]="isHeader ? 'tableHeaderCheckbox' : 'tableRowCheckbox'" *ngIf="selectOption" [checked]=" (isHeader && isHeaderSelected !== 'no') || isSelected" [indeterminate]="(isHeader && isHeaderSelected === 'partial' ? 'indeterminate' : null)" (change)="selectRow($event)">
    DISABLED-LABEL
</mat-checkbox>

<ng-content></ng-content>

<!-- Optional Menu Action -->
<ng-container *ngIf="hasOptionalMenuAction; else noOptionalMenuAction">
    <button
        [attr.data-test-id]="isHeader ? 'tableHeaderCheckbox' : 'tableRowCheckbox'"
        mat-icon-button
        matTooltip="Options"
        [matMenuTriggerFor]="optionalMenuAction"
        [matMenuTriggerData]="optionalMenuActionData"
    >
        <mat-icon data-test-id="icon">more_horiz</mat-icon>
    </button>
</ng-container>
<!-- This will reserve a column -->
<ng-template #noOptionalMenuAction>
    <span></span>
</ng-template>